module.exports = __webpack_public_path__ + "static/media/puerto-rico.212232ee.png";